import { Necrosis } from "./necrosis";
import { Rct } from "./rct";
import { ApicalLesion } from "./apical-lesion";
import { BrokenInstrument } from "./broken-instrument";
import { RootResorption } from "./root-resorption";

export const conditions = [
  Necrosis,
  Rct,
  ApicalLesion,
  BrokenInstrument,
  RootResorption,
];



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/endodontics/index.ts